export enum countriesEnum {
  CRI = 'CRI',
  PAN = 'PAN',
  GTM = 'GTM',
}
